// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_bn-b";
export var colorBlue = "_bn-8";
export var colorDot = "_bn-0";
export var colorDotLarge = "_bn-2";
export var colorDotSmall = "_bn-1";
export var colorGreen = "_bn-7";
export var colorGrey = "_bn-3";
export var colorOrange = "_bn-5";
export var colorPink = "_bn-a";
export var colorPurple = "_bn-9";
export var colorRed = "_bn-4";
export var colorYellow = "_bn-6";